import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "antd";

import { GET_EXHIBITIONS_CURSOR } from "graphql/query/exhibition-gql";

import Exhibition from "components/exhibition";
import Organizer from "components/organizer";
import Icons from "components/icons";
import { useBreadCrumbs } from "components/use-hooks";
import { Tables } from "components/layout";
import { Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";

const { Search } = Input;

const basePath = Exhibition.Const.basePath;
const organizerBasePath = Organizer.Const.basePath;
const tableHelper = Exhibition.Helpers.TableMain;


interface IOrganizerEhibitionSubPageProps
{
  organizer: TOrganizer | undefined;
}


const OrganizerEhibitionSubPage: React.FC<IOrganizerEhibitionSubPageProps> = ({ organizer }) =>
{
  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_Organizers"),
      path: `${organizerBasePath}`,
    },
    {
      label: organizer?.title ?? localizeByKey("VARIABLE.Label_EMPTY"),
      path: `${organizerBasePath}/${organizer?.id}`,
    },
    {
      label: localizeByKey("BREADCRUMBS.Label_Exhibitions"),
      path: `${organizerBasePath}/${organizer?.id}${basePath}`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const [ searchText, setSearchText ] = useState("");
  const navigate = useNavigate();

  return (
    <Tables.Cursor
      model="exhibitionTypesCursor"
      query={GET_EXHIBITIONS_CURSOR}
      varSet={{ perPage: 50 }}
      routeUrl={`${basePath}`}
      searchText={searchText}
      tableHelper={tableHelper}
      currentObj={organizer}
      objectWhere={{
        column: "ORGANIZER_ID",
        operator: "EQ",
        value: organizer?.id,
      }}
    >
      <div className="table-action-bar">
        <div className="col">
          <Search
            className="filter-search"
            prefix={<Icons.Search />}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Button disabled icon={<Icons.Filter />}>
            <span className="ellipsis">
              <Localize>FORMS.Button_Text_Filters</Localize>
            </span>
          </Button>
        </div>

        <div className="col">
          <Button
            type="primary"
            icon={<Icons.Plus />}
            onClick={() =>
              navigate(
                `${organizerBasePath}/${organizer?.id}${basePath}/create`
              )
            }
          >
            <span className="ellipsis">
              <Localize>GLOBAL.Button_Text_CreateNew</Localize>
            </span>
          </Button>
        </div>
      </div>
    </Tables.Cursor>
  );
};

export default OrganizerEhibitionSubPage;
